// helper that can be used on the sign up form -- and soon login and forgot password
import { ProPageStrings } from '../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const validEmailRegex = RegExp(
  /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
);

const validateUserForm = (name, value, errors) => {
  const { email, password, firstName, lastName } = ProPageStrings.loginForm;
  switch (name) {
    case 'forgotPasswordEmail':
    case 'userRegEmail':
    case 'userEmail':
      errors[name] = !validEmailRegex.test(value) ? email.validation.generic : '';
      break;
    case 'userRegPassword':
    case 'userPassword':
    case 'password':
    case 'confirmPassword':
      errors[name] = value.length < 6 ? password.validation.generic : '';
      break;
    case 'userRegFirstName':
      errors[name] = value.length < 1 ? firstName.validation.generic : '';
      break;
    case 'userRegLastName':
      errors[name] = value.length < 1 ? lastName.validation.generic : '';
      break;
    default:
      break;
  }

  return { errors };
};

const hasErrors = errors => {
  for (const name in errors) {
    if (errors[name].length > 0) {
      return true;
    }
  }
  return false;
};

export { validateUserForm, hasErrors };
